export default function ModalBody(props) {
  return <div className={`modal-body ${props.className ?? props.class ?? ""}`}>{props.children}</div>;
}
